/* unplugin-vue-components disabled */import { render } from "./TabName.vue?vue&type=template&id=5302314b&ts=true"
import script from "./TabName.vue?vue&type=script&lang=ts"
export * from "./TabName.vue?vue&type=script&lang=ts"

import "./TabName.vue?vue&type=style&index=0&id=5302314b&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__